define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseDropdownViewController = require('web-agent-components/BaseDropdownViewController');

    var MultiSelectionDropdownViewController = BaseDropdownViewController.extend({
        ControllerName: "MultiSelectionDropdownViewController",

        LPViewMap: {
        },

        initialize: function () {
            this.itemClicked = this.configuration.itemClicked;
            this.context = this.configuration.context || this;
        },

        events: function () {
        },

        render: function () {
        }
    });

    MultiSelectionDropdownViewController.prototype.getConfiguration = function () {
        var configuration = {
            rowTemplateFile: "LP_multi_select_dropdown_row.html"
        };
        var baseDataRenderer = lpUtils.cloneObject(BaseDropdownViewController.prototype.dataRenderer);
        if (baseDataRenderer) {
            baseDataRenderer.dataForRowInSection = function (data, rowIndex) {
                var rowData = data[rowIndex];
                var value = {text: "", rowData: rowData, id: rowIndex};
                value.text = typeof rowData === 'string' ? rowData : rowData[this.textProperty];
                value.title = rowData.title || "";
                value.disabled = rowData.disabled ? "disabled" : "";
                value.checked = data[rowIndex].checked ? "checked" : "";
                return value;
            };
            configuration.dataRenderer = baseDataRenderer;
        }
        return configuration;
    };

    MultiSelectionDropdownViewController.prototype.onFocusedViewClicked = function () {
        BaseDropdownViewController.prototype.onFocusedViewClicked.call(this);
        if (!this.itemsDisplayed) {
            this.expandItems();
        }
    };

    MultiSelectionDropdownViewController.prototype.onItemClicked = function (data) {
        BaseDropdownViewController.prototype.onItemClicked.call(this, data);
        this.dropdownView.focus();
        data.rowData.checked = !data.rowData.checked;
        this.modelChanged();
        this.itemClicked.call(this.context, data);
    };

    return MultiSelectionDropdownViewController;

});
